

<h1 class="page-header">NordNative Support</h1>

<div class="container">
    <p>
        Need help with our services? We are here to assist you. Reach out to us through email, phone or WhatsApp for
        quick and reliable support.
    </p>

    <div class="support-option">
        <h2>Email Support</h2>
        <p>Send us an email with your questions, issues, or feedback, and our support team will respond promptly.</p>
        <p><strong>Email:</strong> <a href="mailto:{{SUPPORT_EMAIL}}">{{SUPPORT_EMAIL}}</a></p>
        <div class="cta">
            <a href="mailto:{{SUPPORT_EMAIL}}">Contact via Email</a>
        </div>
    </div>

    <div class="support-option">
        <h2>Phone Support</h2>
        <p>Call our support team on phone for instant assistance and troubleshooting.</p>
        <p><strong>Phone:</strong> <a href="tel:{{CONTACT_US_PHONE_MAIN}}" target="_blank">{{CONTACT_US_PHONE_MAIN}}</a>
        </p>
        <div class="cta">
            <a href="tel:{{CONTACT_US_PHONE_MAIN}}" target="_blank">Call Now</a>
        </div>
    </div>

    <div class="support-option">
        <h2>WhatsApp Support</h2>
        <p>Chat with our support team on WhatsApp for instant assistance and troubleshooting.</p>
        <p><strong>WhatsApp:</strong> <a href="https://wa.me/{{CONTACT_US_WHATSAPP_MAIN}}"
                target="_blank">+{{CONTACT_US_WHATSAPP_MAIN}}</a></p>
        <div class="cta">
            <a href="https://wa.me/{{CONTACT_US_WHATSAPP_MAIN}}" target="_blank">Chat on WhatsApp</a>
        </div>
    </div>

    <p>
        Our support team is available <strong>Monday to Friday</strong> from
        <strong>9:00 AM to 6:00 PM Central European Time (CET)</strong>. We strive to resolve your queries as quickly as
        possible.
    </p>
</div>

<div class="col-xs-12" style="height:50px;"></div>